document.addEventListener('turbolinks:load', () => {
    //Take guest first, because with 2 screens only the guest screen is relevant
    const safetyConfirmPreviewScreen = document.getElementById('sgScreenGuest') || document.getElementById('sgScreen')
    const safetyConfirmCheckbox = document.getElementById('safetyConfirmCheckbox')
    const safetyConfirmCheckboxText = document.getElementById('safetyConfirmCheckboxText')
    const safetyConfirmCheckboxInput = document.getElementById('safetyConfirmCheckboxInput')
    const safetyConfirmPreviewNextButton = document.getElementById('safetyConfirmPreviewNextButton')
    const safetyConfirmPreviewNextLink = document.getElementById('safetyConfirmPreviewNextLink')
    const safetyConfirmPreviewIconCircle = document.getElementById('safetyConfirmPreviewIconCircle')


    if (safetyConfirmPreviewScreen !== null && safetyConfirmCheckboxInput !== null &&
        safetyConfirmPreviewNextButton !== null && safetyConfirmPreviewNextLink !== null) {
        safetyConfirmCheckboxInput.addEventListener('change', function(){
            changeConfirmScreenStyle(this.checked)
        })
    }

    function changeConfirmScreenStyle(checked) {
        if (safetyConfirmCheckbox.dataset.confirmationScreenChange === "true") { // change is enabled
            if (checked) {
                useConfirmPreviewElementsChangedStyle()
                safetyConfirmCheckboxInput.style.backgroundImage = `url("data:image/svg+xml,%3csvg viewBox='0 0 200 200'  fill='${safetyConfirmCheckbox.dataset.changedColor.replace('#', '%23')}' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M 0.00,0.00 C 0.00,0.00 200.00,0.00 200.00,0.00 200.00,0.00 200.00,200.00 200.00,200.00 200.00,200.00 0.00,200.00 0.00,200.00 0.00,200.00 0.00,0.00 0.00,0.00 Z M 140.00,56.42 C 132.99,58.88 128.14,64.86 123.00,70.00 123.00,70.00 97.00,96.00 97.00,96.00 94.48,98.52 84.60,109.12 82.00,109.80 78.74,110.66 75.07,106.06 73.00,104.00 67.95,98.97 62.96,92.60 55.00,93.56 47.77,94.43 42.68,100.73 43.56,108.00 44.20,113.35 47.42,116.36 51.00,120.00 51.00,120.00 67.00,136.00 67.00,136.00 70.95,139.89 74.17,143.39 80.00,143.89 89.51,144.71 95.94,136.06 102.00,130.00 102.00,130.00 137.00,95.00 137.00,95.00 141.21,90.79 152.20,80.43 154.77,76.00 160.27,66.56 154.55,54.34 140.00,56.42 Z'/%3e%3c/svg%3e")`
            } else {
                useConfirmPreviewElementsDefaultStyle()
                safetyConfirmCheckboxInput.style.backgroundImage = 'none'
            }
        } else { //No design change on check. only display checkmark
            if (checked) {
                safetyConfirmCheckboxInput.style.backgroundImage = `url("data:image/svg+xml,%3csvg viewBox='0 0 200 200'  fill='${safetyConfirmCheckbox.dataset.defaultColor.replace('#', '%23')}' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M 0.00,0.00 C 0.00,0.00 200.00,0.00 200.00,0.00 200.00,0.00 200.00,200.00 200.00,200.00 200.00,200.00 0.00,200.00 0.00,200.00 0.00,200.00 0.00,0.00 0.00,0.00 Z M 140.00,56.42 C 132.99,58.88 128.14,64.86 123.00,70.00 123.00,70.00 97.00,96.00 97.00,96.00 94.48,98.52 84.60,109.12 82.00,109.80 78.74,110.66 75.07,106.06 73.00,104.00 67.95,98.97 62.96,92.60 55.00,93.56 47.77,94.43 42.68,100.73 43.56,108.00 44.20,113.35 47.42,116.36 51.00,120.00 51.00,120.00 67.00,136.00 67.00,136.00 70.95,139.89 74.17,143.39 80.00,143.89 89.51,144.71 95.94,136.06 102.00,130.00 102.00,130.00 137.00,95.00 137.00,95.00 141.21,90.79 152.20,80.43 154.77,76.00 160.27,66.56 154.55,54.34 140.00,56.42 Z'/%3e%3c/svg%3e")`
                enable_link()
            } else {
                safetyConfirmCheckboxInput.style.backgroundImage = 'none'
                disable_link()
            }
        }
    }

    function useConfirmPreviewElementsDefaultStyle() {
        // background
        updatePreviewBackground(safetyConfirmPreviewScreen, "notice", safetyConfirmPreviewScreen.dataset.defaultColor)

        // ################
        // ####  icon  ####
        //#################
        updatePreviewColor(safetyConfirmPreviewIconCircle, "color", false, safetyConfirmPreviewIconCircle.dataset.defaultColor)
        updatePreviewColor(safetyConfirmPreviewIconCircle, "background",
            safetyConfirmPreviewIconCircle.dataset.defaultBackgroundTransparent === "true", safetyConfirmPreviewIconCircle.dataset.defaultBackground)
        updatePreviewTransparency(safetyConfirmPreviewIconCircle.dataset.defaultBackgroundTransparent === "true", safetyConfirmPreviewIconCircle,
            safetyConfirmPreviewIconCircle.dataset.defaultBackground)

        // ################
        // ### checkbox ###
        //#################
        updatePreviewColor(safetyConfirmCheckbox, "background",
            safetyConfirmCheckbox.dataset.defaultBackgroundTransparent === "true", safetyConfirmCheckbox.dataset.defaultBackground)
        updatePreviewTransparency(safetyConfirmCheckbox.dataset.defaultBackgroundTransparent === "true", safetyConfirmCheckbox,
            safetyConfirmCheckbox.dataset.defaultBackground)
        updatePreviewColor(safetyConfirmCheckboxText, "color", false, safetyConfirmCheckbox.dataset.defaultColor)
        updatePreviewColor(safetyConfirmCheckboxInput, "border", false, safetyConfirmCheckbox.dataset.defaultColor)

        // ################
        // ###  button  ###
        //#################

        disable_link()

    }

    function useConfirmPreviewElementsChangedStyle() {
        // background
        updatePreviewBackground(safetyConfirmPreviewScreen, "confirm", safetyConfirmPreviewScreen.dataset.changedColor)

        // ################
        // ### icon ###
        //#################
        updatePreviewColor(safetyConfirmPreviewIconCircle, "color", false, safetyConfirmPreviewIconCircle.dataset.changedColor)
        updatePreviewColor(safetyConfirmPreviewIconCircle, "background",
            safetyConfirmPreviewIconCircle.dataset.changedBackgroundTransparent === "true", safetyConfirmPreviewIconCircle.dataset.changedBackground)
        updatePreviewTransparency(safetyConfirmPreviewIconCircle.dataset.changedBackgroundTransparent === "true", safetyConfirmPreviewIconCircle, safetyConfirmPreviewIconCircle.dataset.changedBackground)

        // ################
        // ### checkbox ###
        //#################
        updatePreviewColor(safetyConfirmCheckbox, "background",
            safetyConfirmCheckbox.dataset.changedBackgroundTransparent === "true", safetyConfirmCheckbox.dataset.changedBackground)
        updatePreviewTransparency(safetyConfirmCheckbox.dataset.changedBackgroundTransparent === "true", safetyConfirmCheckbox,
            safetyConfirmCheckbox.dataset.changedBackground)
        updatePreviewColor(safetyConfirmCheckboxText, "color", false, safetyConfirmCheckbox.dataset.changedColor)
        updatePreviewColor(safetyConfirmCheckboxInput, "border", false, safetyConfirmCheckbox.dataset.changedColor)

        // ################
        // ### button  ###
        //#################

        enable_link()
    }

    function updatePreviewBackground(element, type, value) {
        // get background information
        let backgroundSrc
        if (type === "confirm") {
            backgroundSrc = safetyConfirmPreviewScreen.dataset.changedBackground
        } else if (type === "notice") {
            backgroundSrc = safetyConfirmPreviewScreen.dataset.defaultBackground
        }

        // set background if src exists, color otherwise
        if (backgroundSrc !== "") {
            element.style.backgroundImage = `url(${backgroundSrc})`
        } else {
            element.style.backgroundImage = 'none'
            element.style.backgroundColor = value
        }
    }

    function updatePreviewColor(element, type, transparent, value) {
        // const dataType = safetyNoticePreviewScreen.dataset.dataType
        // if (dataType === 'TEXT_WITH_ICON' ||
        //     element === safetyNoticePreviewNextButton || element === safetyNoticeVideoReplayButton) {
            if (!transparent) {
                if (type === "background") {
                    element.style.backgroundColor = value
                } else if (type === "border") {
                    element.style.borderColor = value
                } else {
                    element.style.color = value
                }
            }
        // }
    }

    function updatePreviewTransparency(transparent, background, value) {
        // const dataType = safetyNoticePreviewScreen.dataset.dataType
        // if (dataType === 'TEXT_WITH_ICON' ||
        //     background === safetyNoticePreviewNextButton || background === safetyNoticeVideoReplayButton) {
            if (transparent) {
                background.style.backgroundColor = null
            } else {
                background.style.backgroundColor = value
            }
        // }
    }

    function enable_link(){
        safetyConfirmPreviewNextButton.classList.add('hidden')
        safetyConfirmPreviewNextLink.classList.remove('hidden')
    }

    function disable_link() {
        safetyConfirmPreviewNextLink.classList.add('hidden')
        safetyConfirmPreviewNextButton.classList.remove('hidden')
    }
})